import type { GetBranchesResData, GetCountersResData } from '~/types/counter'

import { publicApi } from './api'

const getBranches = async (): Promise<GetBranchesResData> => {
  const response = await publicApi.get<GetBranchesResData>('/public/counter')

  return response.data
}

const getCounters = async (id: number): Promise<GetCountersResData> => {
  const response = await publicApi.get<GetCountersResData>(`/public/counter/${id}`)

  return response.data
}

export default { getBranches, getCounters }
